export const forms: TableModule = {
    name: "forms",
    route: "spa.basedata.forms",
    defaultOrder: {
        column: "funding_programs.name|sort",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            sortBy: "name",
            mobile: true,
            width: "w-auto"
        }, {
            name: "identifier",
            sortable: true,
            sortBy: "identifier",
            width: "w-1/6",
            breakpoint: "lg"
        }, {
            name: "type",
            sortable: true,
            sortBy: "type",
            breakpoint: "xl"
        }, {
            name: "fundingProgram",
            sortable: true,
            sortBy: "funding_programs.name",
            width: "w-auto",
            breakpoint: "md"
        }, {
            name: "is_active",
            width: "w-1/6 lg:w-1/12"
        }, {
            name: "sort",
            sortable: true,
            sortBy: "sort",
            width: "w-1/6 lg:w-1/12"
        }
    ],
    filters: [
        {
            name: "id",
            column: "forms.id",
            type: "numeric"
        }, {
            name: "name",
            column: "forms.name",
            type: "string"
        }, {
            name: "fundingProgram",
            column: "forms.funding_program_id",
            type: "searchSelect",
            apiRoute: "spa.basedata.fundingPrograms.index",
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
                orderBy: 'customOrderSortByParent',
                orderDirection: 'asc',
            },
        }
    ],
    quickFilters: [
        {
            name: "qf_activeOnly",
            column: "customFilterActive",
            value: "1",
            operator: "="
        }
    ],
    tools: [
        {
            name: "forms.create",
            isCreateAction: true,
            ability: [
                "create",
                "forms"
            ]
        }
    ]
}